<template >
    <div
        id="app"
        :class="{ 'show-alert': topBarIsRendered }"
        class="wrapper"
    >
        <TopbarAlert></TopbarAlert>
        <page-login
            v-if="displayAuthFullOverlay"
            :image="loginImage"
        >
        </page-login>
        <page-loading v-else-if="displayLoadingFullOverlay">
        </page-loading>
        <slot v-else>
        </slot>
    </div>
</template>

<script>
/*global VERSION:true*/
import PageLogin from './components/auth/index.vue';
import PageLoading from './components/loading/index.vue';
import TopbarAlert from './components/layouts/dashboard/TopbarAlert';
import axios from 'axios';
import { mapGetters } from 'vuex';

import 'element-ui/lib/theme-chalk/index.css';

export default {
    name: 'App',
    components: {
        PageLogin,
        PageLoading,
        TopbarAlert,
    },
    data() {
        return {
            checkVersionHandler: null,
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'displayAuthFullOverlay',
            'displayLoadingFullOverlay',
            'topBarIsRendered',
            'loginImage',
            'defaultLanguage'
        ]),
    },

    created(){
        this.$store.dispatch('fundation/is_up_to_date');
        this.$store.dispatch('fundation/set_online');
        this.$store.dispatch('fundation/changeLang', this.defaultLanguage);
        this.checkVersion();
    },

    destroyed(){
        clearTimeout(this.checkVersionHandler);
    },

    methods: {
        logout(){
            this.$store.dispatch('logoutUser');
        },


        checkVersion() {
            // 1. check remote server status
            axios.get(this.$store.getters.apiStatusUrl).then((response) => {
                // SET_DATASTORE_VERSION
                // DONT_RETRY_STATUS
                // state.dataStoreVersion
                // hasStatusAvailable
                if(response.data.version != this.$store.state.fundation.dataStoreVersion){
                    this.$store.commit('fundation/SET_DATASTORE_VERSION', response.data.version);
                    console.log(`Datastore version is ${response.data.version}`);
                }
                this.$store.dispatch('fundation/set_online');

                // // 2. check current app status
                if(this.$store.state.fundation.hasStatusAvailable){
                    axios.get(this.$store.getters.appStatusUrl).then(result => {
                        try {
                            if (result.data.version == VERSION) {
                                this.$store.dispatch('fundation/is_up_to_date');
                            } else {
                                this.$store.dispatch('fundation/need_update');
                            }
                        } catch (e) {
                            console.error('Cannot check version, please ensure webpack build-tool is well configured');
                            this.$store.dispatch('fundation/is_up_to_date');
                        }
                    }).catch((error) => {
                        if(error.response.status == 404){
                            this.$store.commit('fundation/DONT_RETRY_STATUS');
                        }
                        this.$store.dispatch('fundation/is_up_to_date');
                    });
                }
                else{
                    this.$store.dispatch('fundation/is_up_to_date');
                }

            }).catch(() => {
                this.$store.dispatch('fundation/is_up_to_date');
                this.$store.dispatch('fundation/set_offline');
            }).finally(() => {
                this.checkVersionHandler = setTimeout(this.checkVersion, 10000);
            });
        },
    },
};
</script>

<style lang="scss">
// .fundation-dashboard{
//     @import "./themes/dashboard/sass/main.scss";
// }
.el-form-item__label, .el-table .cell{
    word-break: break-word !important;
}
.input-help-text{
  font-size: 12px;
  font-style: italic;
  color: #a9a9a9;
  line-height: 15px
}

#app{
  transition: 1s padding-top ease;
  .main-sidebar {
    transition: 1s padding-top ease;
  }
}
#app.show-alert {
    transition: 1s ;
    padding-top: 32px;
    .main-header {
      top: 32px;
    }
    .main-sidebar {
      padding-top: 32px;
    }
}
    /* patch */
body{
    font-family: "Montserrat", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-weight: 300;
    overflow-x: hidden;
    font-size: 14px !important;
    -webkit-font-smoothing: antialiased;

    .main-sidebar{
         background: #333333 !important;
         border-right: 1px solid rgba(0, 0, 0, 0.05);
    }
    .main-header .navbar {
        background-color: #fff;
    }

    .content-header .breadcrumb li a{
        color: #222 !important;
    }
    .page-header {
        position: relative;
        padding: 45px;
        overflow: hidden;
        background: black;
        margin: 0 !important;
    }
    .content-wrapper {
        background: #eee;
    }

    .main-header .logo {
        background-color: #333333;
        color: #fff;
        -webkit-box-shadow: -5px 4px 20px -4px rgba(0, 0, 0, 0.5);
        box-shadow: -5px 4px 20px -4px rgba(0, 0, 0, 0.5);
    }
    .user-panel .bg-user {
        opacity: 0.1 !important;
    }
    .user-panel > .info {
        color: #fff !important;
    }

  .fundation-plus-sign{
    width: 80px;
    height: 80px;
    &:before{
        content: "";
        width: 80px;
        height: 2px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        transition: all .3s ease;
        background-color: #fff;
    }
    &:after{
        content: "";
        height: 80px;
        width: 2px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        transition: all .5s ease;
        background-color: #fff;
    }

    &:hover{
      &:before{
          content: "";
          width: 80px;
          height: 2px;
          position: absolute;
          transform: translate(-50%, -50%) scale(1.1);
      }
      &:after{
          content: "";
          height: 80px;
          width: 2px;
          position: absolute;
          transform: translate(-50%, -50%) scale(1.1);
      }
    }
  }

  .fundation-cross-sign{
      transform: rotate(45deg);
    &:hover{
      &:before{
          background-color: #ff4c4c;
      }
      &:after{
          background-color: #ff4c4c;
      }
    }
  }
}


.ns-loading-overlay{
    position: absolute;
    top: calc(50% - 150px/2);
    left: calc(50% - 200px/2);
    z-index: 9999;
    width: 200px;
    height: 150px;
    background-color: rgba(0,0,0,.4);
    border-radius: 5px;
  .ring-container{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .lds-ring {
      display: inline-block;
      position: relative;
      width: 64px;
      height: 64px;
    p{
        color: white;
        text-transform: uppercase;
        position: absolute;
        top: 64px;
      }
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 51px;
      height: 51px;
      margin: 6px;
      border: 6px solid #fff;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

  }
}

#id-div-login-container{
  .el-alert{
      margin-bottom: 15px;
  }
  .el-alert:last-child{
      margin-bottom: 0px;
  }
}

.transfert-sized{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .el-transfer-panel{
        width: 100%;
        @media (min-width: 500px) {
            width: 40%;
        }
        .el-transfer-panel__body {
            height: 180px;
            @media (min-width: 500px) {
                height: 250px;
            }
        }
    }
    .el-transfer__buttons{
        display: flex;
        width: 100%;
        @media (min-width: 500px) {
            display: inherit;
            width: 20%;
        }
        button{
            margin: 10px auto;
            transform: rotate(90deg);
            @media (min-width: 500px) {
                transform: unset;
                vertical-align: middle;
                margin: auto;
                margin-bottom: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/App.vue